import { ConstructionLeadState, StatusFilterEnum } from '.';

export const initialState: ConstructionLeadState = {
  List: [],
  loading: false,
  buttonLoading: false,
  search: '',
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  orderBy: '',
  orderDir: '',
  status: StatusFilterEnum.ALL,
  endDate: '',
  startDate: ''
};
